import * as React from 'react';
import clx from 'classnames';
import { Button, Col, Row, Tooltip, Typography } from 'antd';
const { Title, Text, Paragraph } = Typography;
import './DocumentTitleRow.scss';
import { RowProps } from 'antd/lib/row';
import { ReadDocumentIcon } from './ReadDocumentIcon';
import { DownloadOutlined, FileTextOutlined } from '@ant-design/icons';
import { resolveApiPath } from 'client/core/appConfig';
import { IProcedureBridgeDocumentInfo } from 'common/dto/ProcedureBridgeDto';
import { ResponsiveHide } from 'client/ui/responsive/ResponsiveHide';

export interface DocumentTitleRowProps extends RowProps {
  documentInfo?: IProcedureBridgeDocumentInfo;
  token: string;
  requestId: number;
  isAdmin?: boolean;
}

/**
 * Riga contenitore per pagina documento
 */
export function DocumentTitleRow(props: DocumentTitleRowProps) {
  const {
    align,
    className,
    documentInfo,
    requestId,
    token,
    children,
    isAdmin,
    ...othersProps
  } = props;

  return (
    <Row
      align="middle"
      className={clx('document-title-row', className)}
      {...othersProps}
    >
      <Col className="icon-cell">
        {!isAdmin && <ReadDocumentIcon document={documentInfo} />}
        <FileTextOutlined />
      </Col>

      <Col className="title-cell">
        <Row>
          <Title level={4}>{documentInfo?.name}</Title>
        </Row>
      </Col>
      <Col className="action-cell">
        <Tooltip title="Download Documento">
          <a
            href={resolveApiPath(
              `/requests/${requestId}/document/${token}/download`
            )}
            target="_blank"
          >
            <Button type="primary" size="large" icon={<DownloadOutlined />}>
              <ResponsiveHide mobileOnly inline>
                {' '}
                Download
              </ResponsiveHide>
            </Button>
          </a>
        </Tooltip>
      </Col>
    </Row>
  );
}
